import script from "./roadRescue.vue?vue&type=script&lang=ts&setup=true"
export * from "./roadRescue.vue?vue&type=script&lang=ts&setup=true"

import "./roadRescue.vue?vue&type=style&index=0&id=7ecd3fc0&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ecd3fc0"]])

export default __exports__